import React, { useContext } from 'react'
import { Input, Popover } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import { FormLayoutRow, Well } from '@pushly/aqe/lib/components'
import { PromptEditorTreatment } from '../types'
import { useDebouncer } from '@pushly/aqe/lib/hooks'
import { DEFAULT_INPUT_FIELD_DEBOUNCE_MS, VARIANT_NAME_MAX_CHARS } from '../constants'
import { PromptEditorDispatchContext } from '../reducer'
import { PromptEditorContext } from '../context'

export const PromptAbVariantDetails = () => {
    const dispatch = useContext(PromptEditorDispatchContext)
    const { loading, selectedPrompt, selectedPromptIdx } = useContext(PromptEditorContext)

    const [debounce] = useDebouncer(DEFAULT_INPUT_FIELD_DEBOUNCE_MS)

    const setVariant = (setter: (update: PromptEditorTreatment) => PromptEditorTreatment) => {
        if (loading) return
        dispatch({ type: 'set-prompt', idx: selectedPromptIdx, prompt: setter(selectedPrompt.clone()) })
    }

    return (
        <Well hideHeader={true} hideFooter={true} mode="ghost">
            <div className="prompt-test-setup-well">
                <FormLayoutRow
                    loading={loading}
                    layout="vertical"
                    label="Variant Name"
                    value={
                        !loading && (
                            <Input
                                key={selectedPromptIdx}
                                placeholder="Prompt Variant Name"
                                maxLength={VARIANT_NAME_MAX_CHARS}
                                defaultValue={selectedPrompt.name ?? undefined}
                                onChange={(ev) => {
                                    debounce(() =>
                                        setVariant((update) => {
                                            update.name = ev.target.value
                                            return update
                                        }),
                                    )
                                }}
                            />
                        )
                    }
                />

                <div className="display-weight">
                    <FormLayoutRow
                        loading={loading}
                        layout="vertical"
                        label={
                            <div>
                                <Popover
                                    overlayClassName="prompt-display-weight-info-popover"
                                    content={
                                        <span>
                                            Display weight determines the percent of site visitors that will see the
                                            currently selected prompt test. The display weight must add up to 100%
                                            across all tests.
                                        </span>
                                    }
                                >
                                    Display Weight
                                    <span className="info-icon">
                                        <InfoCircleOutlined />
                                    </span>
                                </Popover>
                            </div>
                        }
                        value={
                            !loading && (
                                <Input
                                    key={selectedPromptIdx}
                                    placeholder="0"
                                    addonAfter="%"
                                    type="number"
                                    max={100}
                                    min={0}
                                    maxLength={3}
                                    defaultValue={selectedPrompt.weight ?? 0}
                                    onChange={(ev) => {
                                        debounce(() =>
                                            setVariant((update) => {
                                                update.weight = ev.target.value as any
                                                try {
                                                    update.weight = parseInt(ev.target.value, 10)
                                                } catch (e) {}
                                                return update
                                            }),
                                        )
                                    }}
                                />
                            )
                        }
                    />
                </div>
            </div>
        </Well>
    )
}
